export interface PublicationData {
  url: string;
  platform: PublicationTypeEnum;
  status: PublicationStatus;
}

export enum PublicationStatus {
  Fresh = 0,
  Verified = 1,
  Error = 2,
  NotFound = 3,
  RestrictedByAge = 4,
  HiddenLikesEnabled = 5,
  StatsUnavailable = 6,
}

export enum PublicationTypeEnum {
  INSTAGRAM_POST = "instagram",
  INSTAGRAM_REEL = "instagramReels",
  INSTAGRAM_STORY = "instagramStory",
  TIKTOK_POST = "tiktok",
  YOUTUBE_VIDEO = "youtubeVideo",
  YOUTUBE_SHORT = "youtubeShort",
  FACEBOOK_POST = "facebook",
  SNAPCHAT_STORY = "snapchatStory",
  SNAPCHAT_SPOTLIGHT = "snapchatSpotlight",
  DISCORD_POST = "discordPost",
  TWITTER_POST = "twitterPost",
  TWITCH_VIDEO = "twitchVideo",
}

export interface PublishedContent {
  uuid: string;
  created: string;
  name: string;
  mimeType: string;
  downloadUrl: string;
  thumbnails: {
    tiny: string | null;
    small: string | null;
    big: string | null;
  };
  isUrlFile: boolean;
}
